export const ru = {
    'less-then-min-limit': 'Максимальный расход не может быть меньше {minLimit}%',
    'limit-must-be-set': 'Необходимо установить максимальный расход: введите целое число от {minLimit} до {maxLimit}',
    'more-then-max-limit': 'Максимальный расход не может быть больше {maxLimit}%',
    'unavailable-goal': 'Выбранная цель недоступна'
};
